import React, { useMemo } from 'react';
import { RiPauseLine } from 'react-icons/ri';
import { v4 as uuidv4 } from 'uuid';

import Mode from './Mode';

import { getModeId } from '@/utils/CommandUtils';

const Panel = ({ data: robots }) => {
  const modeId = useMemo(() => {
    return getModeId(robots[0].model.vehicle, 'LOITER');
  }, [robots]);

  return <Mode data={robots} modeId={modeId} desc="Holds position using GPS and hovers in place" />;
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Loiter';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiPauseLine;
Command.Panel = Panel;

export default Command;
